/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useRef, Fragment} from "react";

import { AppContext } from "../components/AppProvider";
import { _CK, _API, _U } from "../modules/utils";

// UI
import { Loading } from "../components/UI/Loading";
import LoadingShimmer from "../components/UI/LoadingShimmer";
import { _CFG } from "../../../api/src/modules/config";
import useStore from "../modules/utils/store";

export default (props) => {
  const { auth, iam } = useContext(AppContext);
  const { saveAuth, saveIam } = useContext(AppContext);
  const { siteIdx, eventIdx, sessionIdx, passCode, au, type, targetType, preregIdx, redirectHash } = props;
  const { medigate, external, gsk } = props;
  const {name, mobile, email, smsAgree, emailAgree, remoteAddr, companyName} = props;
  const { siteInfo } = useStore();
  const hasStartedDirectLogin = useRef(false);
  const resolvedSiteIdx = siteIdx || siteInfo?.idx;

  const completeDirectLogin = (accessKey, sessionData) => {
    _CK.setAuth(accessKey);
    _CK.forceSetLogKey(sessionData.logKey);
    _CK.setConsoleCountView(0);
    saveIam(sessionData);
    saveAuth(accessKey);
    sessionStorage.removeItem('__directLoginPending');

    const nextHash =
      redirectHash ||
      (window.location.hash ? window.location.hash.split("?")[0] : "");

    if (nextHash) {
      const nextUrl = `${window.location.pathname}${nextHash}`;
      window.location.replace(nextUrl);
    }
  };

  const failDirectLogin = (message) => {
    sessionStorage.removeItem('__directLoginPending');

    if (message) {
      alert(message);
    }

    window.location.href = `/`;
  };

  const directLogin = async () => {
    if (gsk) {
      // GSK 카카오 채널 게스트 로그인.
      // 같은 이벤트·같은 휴대폰번호면 서버가 기존 참가자 행을 재사용한다(중복 방지).
      // 세션은 지정하지 않는다. 로그인 후 세션 리스트(/register)에서 참가자가 고른다.
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/gsk/access",
        data: {
          siteIdx: resolvedSiteIdx,
          eventIdx,
          name,
          mobile,
          userAgent: _U.getUserAgent(),
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {
            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);

            // 쿠키·컨텍스트를 모두 채운 뒤에 이동한다.
            // 인앱브라우저에서 hashchange 만으로는 라우팅이 갱신되지 않는 경우가 있어
            // 이동 후 전체 리로드로 App.js 가 쿠키를 읽고 재초기화하도록 한다.
            const nextHash = redirectHash || `#/event/${eventIdx}/register`;
            window.location.href = `${window.location.pathname}${nextHash}`;
            window.location.reload();
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });
    } else if (medigate || external) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/medigate/access",
        data: {
          siteIdx: resolvedSiteIdx,
          eventIdx,
          sessionIdx,
          name,
          mobile,
          email,
          smsAgree,
          emailAgree,
          companyName,
          remoteAddr,
          targetType: medigate ? "MEDIGATE" : external ? "ICOD" : "",
          userAgent: _U.getUserAgent(),
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {
            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });
    } else if (eventIdx && passCode && !targetType) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/login",
        data: {
          passCode,
          siteIdx: resolvedSiteIdx,
          eventIdx,
          userAgent: _U.getUserAgent(),
          type: type,
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS") {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {
            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });
    } else if (eventIdx && targetType) {

      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);

      const req = {
        path: "/v1/client/external/guest/save",
        data: {
          siteIdx : siteIdx,
          eventIdx : eventIdx,
          sessionIdx : sessionIdx,
          preregIdx : preregIdx,
          passCode : passCode,
          targetType: targetType,
          userAgent: _U.getUserAgent(),
        },
      };

      await _API
        .post(req)
        .then((res) => {
          const { data } = res;

          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {

            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });


    } else if (eventIdx && au) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/adminLogin",
        isNoErrorNotify: true,
        data: {
          siteIdx: resolvedSiteIdx,
          eventIdx,
          userAgent: _U.getUserAgent(),
          email: props?.email,
          memType: props?.memType,
        },
        headers: {
          authorization: au,
          apiKey: _CFG.apiKey,
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            failDirectLogin("접근 권한이 없습니다.");
          } else {
            completeDirectLogin(data.accessKey, data.data);
          }
        })
        .catch((e) => {
          failDirectLogin("접근 권한이 없습니다.");
        });
    }
  };

  useEffect(() => {
    if (hasStartedDirectLogin.current) {
      return;
    }

    const requiresResolvedSiteIdx =
      gsk || medigate || external || (eventIdx && passCode && !targetType) || (eventIdx && au);

    if (requiresResolvedSiteIdx && !resolvedSiteIdx) {
      return;
    }

    hasStartedDirectLogin.current = true;
    directLogin();
  }, [au, eventIdx, external, gsk, medigate, passCode, resolvedSiteIdx, targetType]);

  return (
    <Fragment>
            <LoadingShimmer />
    </Fragment>
  );
};
